/* ============================================================
   Sales Rep Profile — small interactive enhancements
   - Show/hide the sticky mobile contact bar based on scroll past hero
   ============================================================ */
(function () {
  'use strict';

  function initStickyBar() {
    var bar = document.querySelector('.srp-sticky-bar');
    var hero = document.querySelector('.srp-hero');
    if (!bar || !hero) return;

    var hidden = true;
    bar.style.transform = 'translateY(100%)';
    bar.style.transition = 'transform 0.2s ease';

    function update() {
      var heroRect = hero.getBoundingClientRect();
      var shouldShow = heroRect.bottom < 0;
      if (shouldShow && hidden) {
        bar.style.transform = 'translateY(0)';
        hidden = false;
      } else if (!shouldShow && !hidden) {
        bar.style.transform = 'translateY(100%)';
        hidden = true;
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
